<template>
  <button
    class="inline-flex flex-row items-center gap-x-1 text-brand-peacock font-semibold underline uppercase transition-all duration-500 dark:text-brand-cornflower hover:no-underline"
  >
    <Icon
      class="text-xl transition-all duration-500"
      :name="
        isActive
          ? 'material-symbols:bookmark-remove'
          : 'material-symbols:bookmark-add'
      "
    />
    <span class="transition-all duration-500">
      {{ isActive ? t('Remove from Favorites') : t('Save to Favorites') }}
    </span>
  </button>
</template>

<script setup lang="ts">
const { t } = useI18n()

defineProps<{
  isActive: Boolean
}>()
</script>

<i18n lang="json">
{
  "en": {
    "Remove from Favorites": "Remove from Favorites",
    "Save to Favorites": "Save to Favorites"
  },
  "es": {
    "Remove from Favorites": "Eliminar de favoritos",
    "Save to Favorites": "Guardar en favoritos"
  }
}
</i18n>
